class CartDeliveryFeeController {
    constructor($sce, settings, shopperService, trolleyService, deliveryPassService, deliveryFeeService, deliverySaverConstants, fulfilmentService) {
        this.$sce = $sce;
        this.settings = settings;
        this.shopperService = shopperService;
        this.trolleyService = trolleyService;
        this.deliveryPassService = deliveryPassService;
        this.deliveryFeeService = deliveryFeeService;
        this.deliverySaverConstants = deliverySaverConstants;
        this.fulfilmentService = fulfilmentService;
        this.deliveryFeeStructure = null;
    }

    $onInit() {
        this.showDeliveryFeeStructure = false;

        this.deliveryPassService.showShopperDeliveryPassPrompt();

        this.deliveryUnlimitedUrl = this.geteDeliveryUnlimitedUrl();
    }

    toggleDeliveryFeeStructure() {
        this.showDeliveryFeeStructure = !this.showDeliveryFeeStructure;

        if (this.showDeliveryFeeStructure) {
            this.deliveryFeeService.getDeliveryFeeStructure().then((response) => {
                this.deliveryFeeStructure = response;
            });
        }
    }

    showDeliveryPassPrompt() {
        return !this.showDeliveryFeeStructure
            && !this.settings.deliverySaver.isEnabled
            && (this.deliveryPassService.deliveryPassPrompt.ContentText || this.deliveryPassService.deliveryPassPrompt.PromptText);
    }

    showDeliveryPlusSuspended() {
        return this.isDeliveryPlusEnabled()
            && this.deliveryPlus().Status === this.deliverySaverConstants.SUBSCRIPTION_STATUS.SUSPENDED;
    }

    showDeliveryPlusMinimumOrderAmount() {
        return this.shouldSpendMoreMessageDisplay()
            && this.fulfilmentService.isDeliveryPlusEligible
            && this.deliveryPlusOrderAmountNeeded() > 0;
    }

    showDeliveryPlusApplied() {
        return this.shouldSpendMoreMessageDisplay()
            && this.fulfilmentService.isDeliveryPlusEligible
            && this.deliveryPlusOrderAmountNeeded() <= 0;
    }

    shouldSpendMoreMessageDisplay() {
        // diable spend more message until this.trolleyService.itemPriceTotal finish implement exclude non-discountable product
        return false;
    }

    showDeliveryPlusFreeTrial() {
        return this.isDeliveryPlusEnabled()
            && !this.deliveryPlus().Status
            && this.deliveryPlus().IsFreeTrialEligible;
    }

    showDeliveryPlusReturn() {
        return this.isDeliveryPlusEnabled()
            && this.deliveryPlus().Status === this.deliverySaverConstants.SUBSCRIPTION_STATUS.CANCELLED;
    }

    deliveryPlusOrderAmountNeeded() {
        if (!this.isDeliveryPlusEnabled()) return 0;
        if (!this.deliveryPlus().MinimumOrderAmount) return 0;
        const amount = this.deliveryPlus().MinimumOrderAmount - this.trolleyService.itemPriceTotal;
        return amount < 0 ? 0 : amount;
    }

    isDeliveryPlusEnabled() {
        return this.settings.deliverySaver
            && !this.shopperService.shopper.DeliverySaverType // exclude delivery pass user
            && this.settings.deliverySaver.isEnabled
            && this.settings.payment
            && this.settings.payment.enableDigitalPay;
    }

    deliveryPlus() {
        return this.shopperService.shopper.DeliveryPlus || {};
    }

    geteDeliveryUnlimitedUrl() {
        let deliveryUnlimitedUrl = this.settings.deliverySaver.discoverPageUrl;
        if (deliveryUnlimitedUrl.indexOf('?') >= 0) {
            deliveryUnlimitedUrl += '&icmpid=sm-du:side-cart';
        } else {
            deliveryUnlimitedUrl += '?icmpid=sm-du:side-cart';
        }
        return deliveryUnlimitedUrl;
    }
}

CartDeliveryFeeController.$inject = ['$sce', 'Settings', 'ShopperService', 'TrolleyService', 'DeliveryPassService', 'DeliveryFeeService', 'DeliverySaverConstants', 'FulfilmentService'];

const cartDeliveryFeeComponentDefinition = {
    controller: CartDeliveryFeeController,
    template: require('./cart-delivery-fee.component.html').trim(),
};

module.exports = {
    CartDeliveryFeeController,
    cartDeliveryFeeComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/cart/cart-delivery-fee.component.js